import * as React from "react";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { Form } from "informed";
import { UserForm } from "./UserForm";
import { GlobalAuthorization } from "../../misc/components/Authorization";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { useSecurityContext } from "../../Core/SecurityContext";
import { ApiLanguages } from "../../misc/api/AccountServer/AccountApi";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const CreateUserScreen = () => {
    const title = "Create User";
    const { currentUserPermissions } = useSecurityContext();
    const [languageOptions, setLanguageOptions] = React.useState();
    const [timeZoneOptions, setTimeZoneOptions] = React.useState([]);
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const fetchLanguages = async () => {
            const languages = await ApiLanguages();
            setLanguageOptions(languages.data);
        }

        const fetchTimeZoneOptions = async () => {
            const timeZones = await client.client.getTimeZones("id,name", undefined, "sortOrder");
            setTimeZoneOptions(timeZones.value);
            return timeZones.value;
        }

        fetchLanguages();
        fetchTimeZoneOptions();
    }, []);

    return (
        <DocumentTitle title={`${title} | Vitalograph Web Portal`}>
            <GlobalAuthorization permissionId={PermissionEnum.CreateUsers} currentPermissions={currentUserPermissions}>
                <Form noValidate>
                    <UserForm header={title} languageOptions={languageOptions} timeZoneOptions={timeZoneOptions} />
                </Form>
            </GlobalAuthorization>
        </DocumentTitle>
    );
}
